/**
 * AI.GEN lines=1-66
 * 页面动态加载组件
 */
import React, { useEffect, useState } from 'react';
import { execFunction } from '@hpfe/common-base';

import { Error } from '@/components/error';
import { ErrorType } from '@/components/error/enum';
import { LayoutLoading } from '@/components/layout/loading';

type Props = {
  pathname: string;
  onBeforeLoadPage?: () => Promise<void>;
};

export const PageRoot = (props: Props) => {
  const [Component, setComponent] = useState<React.FC>(() => LayoutLoading);
  const filePath = execFunction(() => {
    const path = props.pathname
      .replace(/([A-Z])/g, '-$1')
      .toLowerCase()
      .replace('/admin', '')
      .replace('/', '');

    const paths = path.split('/');
    paths.push('index');
    return paths.join('/');
  });

  const loadPage = async () => {
    const start = Date.now();

    try {
      if (props.onBeforeLoadPage) {
        await props.onBeforeLoadPage();
      }

      const component = await import(
        /* webpackInclude: /\.(tsx|jsx)$/ */
        `../../pages/${filePath}.page`
      );

      const cost = Date.now() - start;
      const delay = Math.max(0, 200 - cost);

      setTimeout(() => {
        setComponent(() => component.default);
      }, delay);
    } catch (e) {
      console.error(`Failed to load page: ${filePath}`, e);

      const ErrorComponent = () => <Error type={ErrorType.pageNotFound} />;

      const cost = Date.now() - start;
      const delay = Math.max(0, 200 - cost);

      setTimeout(() => {
        setComponent(() => ErrorComponent);
      }, delay);
    }
  };

  useEffect(() => {
    loadPage();
  }, [filePath]);

  return <Component></Component>;
};
